import { Alert, AlertTitle, Button, Stack } from '@mui/material';
import { TipsAndUpdatesOutlined } from '@mui/icons-material';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { useSetupGuide } from '@/hooks/useSetupGuide';

/**
 * Guided setup tips (Module 0, O11): a step on Home opens its real screen with `?guide=<step>`, and this
 * banner shows that step's tip above the page until the user goes back or closes it.
 */
export default function SetupTipBanner() {
  const [params, setParams] = useSearchParams();
  const key = params.get('guide');
  const guide = useSetupGuide(!!key);
  if (!key) return null;
  const step = guide.data?.steps.find((s) => s.key === key);
  if (!step) return null;

  const close = () => {
    const next = new URLSearchParams(params);
    next.delete('guide');
    setParams(next, { replace: true });
  };

  return (
    <Alert
      severity="info"
      icon={<TipsAndUpdatesOutlined />}
      onClose={close}
      sx={{ mb: 2, '& .MuiAlert-message': { width: '100%' } }}
    >
      <AlertTitle sx={{ fontWeight: 700 }}>
        Guided setup: {step.title}{step.status === 'Done' ? ' ✓' : ''}
      </AlertTitle>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ sm: 'center' }} justifyContent="space-between">
        <span>{step.tip}</span>
        <Button component={RouterLink} to="/dashboard" size="small" variant="outlined" sx={{ flexShrink: 0, alignSelf: { xs: 'flex-start', sm: 'auto' } }}>
          Back to setup
        </Button>
      </Stack>
    </Alert>
  );
}
